module.exports = "/images/vendor/flag-icon-css/flags/1x1/er.svg?bdfbf04ca25609debe2a56601a13f8a4";